export default "__VITE_ASSET__Dl4Er6P8__"